<app-pias-layout>
  <div pias-layout-content>
    @if(this.setSprinner()) {
    <div class="pias-spinner">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    }
    @if(['NEWREP','Introducer - Individual','Introducer - Corporate'].includes(this.currentUserRole)){
    <app-applicant-navigation></app-applicant-navigation>
    }@else{
    <div id="agent-onboarding-container" class="container-fluid">
      <div id="agent-onboarding-header" class="d-flex justify-content-between">
        <h5 class="page-header">Agent Onboarding</h5>
        <span class="pias-header-spacer"></span>
        @if(this.currentUserRole == 'BDM' || this.currentUserRole == 'Onboarding' || this.currentUserRole == 'DSU' ||
        this.currentUserRole == 'DSU Manager'){

        }@else {
        <button mat-stroked-button id="new-app-btn" class="ms-1" (click)="newApplication()">
          <mat-icon>person_add</mat-icon>
          New Application
        </button>
        }
      </div>

      <div id="agent-onboarding-main-container">
        <!-- Stats Cards -->
        <div class="stats-grid">

          <mat-card class="stat-card" (click)="clickFilters('Draft Created')">
            <mat-card-content>
              <div class="stat-icon-wrap draft">
                <mat-icon>edit_document</mat-icon>
              </div>
              <p class="stat-label">Draft Created</p>
              <h2 class="stat-value">{{ stats.DraftCreated }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('Candidate Submission')">
            <mat-card-content>
              <div class="stat-icon-wrap submission">
                <mat-icon>schedule</mat-icon>
              </div>
              <p class="stat-label">Candidate Submission</p>
              <h2 class="stat-value">{{ stats.CandidateSubmission }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('Manager Review')">
            <mat-card-content>
              <div class="stat-icon-wrap review">
                <mat-icon>rate_review</mat-icon>
              </div>
              <p class="stat-label">Manager Review</p>
              <h2 class="stat-value">{{ stats.ManagerReview }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('Onboarding Processing')">
            <mat-card-content>
              <div class="stat-icon-wrap processing">
                <mat-icon>autorenew</mat-icon>
              </div>
              <p class="stat-label">Onboarding Processing</p>
              <h2 class="stat-value">{{ stats.OnboardingProcessing }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('DSU Initial Assessment')">
            <mat-card-content>
              <div class="stat-icon-wrap initial">
                <mat-icon>assignment</mat-icon>
              </div>
              <p class="stat-label">DSU Initial Assessment</p>
              <h2 class="stat-value">{{ stats.DSUInitialAssessment }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('Rectification')">
            <mat-card-content>
              <div class="stat-icon-wrap rect">
                <mat-icon>edit</mat-icon>
              </div>
              <p class="stat-label">Candidate Update</p>
              <h2 class="stat-value">{{ stats.Rectification }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('BDM Interview')">
            <mat-card-content>
              <div class="stat-icon-wrap interview">
                <mat-icon>forum</mat-icon>
              </div>
              <p class="stat-label">DM Interview</p>
              <h2 class="stat-value">{{ stats.BDMInterview }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('DSU Final Assessment')">
            <mat-card-content>
              <div class="stat-icon-wrap final">
                <mat-icon>assignment_turned_in</mat-icon>
              </div>
              <p class="stat-label">DSU Final Assessment</p>
              <h2 class="stat-value">{{ stats.DSUFinalAssessment }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('DSU Manager Approval')">
            <mat-card-content>
              <div class="stat-icon-wrap approval">
                <mat-icon>pending_actions</mat-icon>
              </div>
              <p class="stat-label">DSU Manager Approval</p>
              <h2 class="stat-value">{{ stats.DSUManagerApproval }}</h2>
            </mat-card-content>
          </mat-card>

          <mat-card class="stat-card" (click)="clickFilters('Onboarding Completed')">
            <mat-card-content>
              <div class="stat-icon-wrap completed">
                <mat-icon>task_alt</mat-icon>
              </div>
              <p class="stat-label">Onboarding Completed</p>
              <h2 class="stat-value">{{ stats.OnboardingCompleted }}</h2>
            </mat-card-content>
          </mat-card>

        </div>
        
        <!-- Table Card -->
        <mat-card class="table-card">
          <mat-card-content>
            <!-- Search -->
            <div class="table-toolbar">
              <div id="agent-onboard-filter-form" class="w-100">
                <form class="row align-items-start" [formGroup]="searchQueryFg">
                  <div class="col-sm-12 col-md-7 col-lg-5 col-xxl-5 m-0">
                    <div class="position-relative" style="max-width: 500px">
                      <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" formControlName="searchApplicants"
                        (keyup)="__applyAgentonboardFilter()" placeholder="Search" />

                      <!-- Search icon -->
                      <i class="fas fa-search position-absolute top-50 start-0 ms-3 translate-middle-y"
                        style="color: #888888"></i>

                      <!-- Clear button -->
                      <button type="button" *ngIf="searchQueryFg.get('searchApplicants')?.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-3 p-0 border-0 bg-transparent"
                        (click)="clearSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Status Filter Dropdown -->
              <div class="col-sm-12 col-md-3 col-lg-2 col-xxl-2 me-2">
                <!-- <mat-label class="field-label">Status Filter</mat-label> -->
                <mat-form-field class="w-100">
                  <mat-select name="selectedStatus" [(ngModel)]="selectedStatus"
                    (selectionChange)="onStatusFilterChange()">
                    <mat-option value="">All Status</mat-option>
                    <mat-option value="Draft Created">Draft Created</mat-option>
                    <mat-option value="Candidate Submission">Candidate Submission</mat-option>
                    <mat-option value="Manager Review">Manager Review</mat-option>
                    <mat-option value="Onboarding Processing">Onboarding Processing</mat-option>
                    <mat-option value="DSU Initial Assessment">DSU Initial Assessment</mat-option>
                    <mat-option value="Rectification">Candidate Update</mat-option>
                    <mat-option value="BDM Interview">DM Interview</mat-option>
                    <mat-option value="DSU Final Assessment">DSU Final Assessment</mat-option>
                    <mat-option value="DSU Manager Approval">DSU Manager Approval</mat-option>
                    <mat-option value="Onboarding Completed">Onboarding Completed</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!-- Data Table -->
            <div class="table-container">
              <table mat-table [dataSource]="pagedApplicants" class="applicants-table">

                <!-- Name Column -->
                <!-- <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Name</th>
                  <td mat-cell *matCellDef="let applicant">
                    <div class="applicant-name">{{ applicant.name }}</div>
                    <div class="applicant-email">{{ applicant.email }}</div>
                  </td>
                </ng-container> -->

                <!-- Position Column -->
                <ng-container matColumnDef="fullNameNric">
                  <th mat-header-cell *matHeaderCellDef>Name</th>
                  <td mat-cell *matCellDef="let applicant">
                    @if(applicant.designation  === 'Introducer - Corporate' ){
                       {{ applicant.companyName }}
                    }@else{
                       {{ applicant.fullNameNric }}
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="designation">
                  <th mat-header-cell *matHeaderCellDef>Designation</th>
                  <td mat-cell *matCellDef="let applicant">{{ applicant.designation }}</td>
                </ng-container>

                <!-- Branch Column -->
                <ng-container matColumnDef="branch">
                  <th mat-header-cell *matHeaderCellDef>Branch</th>
                  <td mat-cell *matCellDef="let applicant">{{ applicant.branch }}</td>
                </ng-container>

                <!-- Requester Column -->
                <ng-container matColumnDef="requesterName">
                  <th mat-header-cell *matHeaderCellDef>Requester Name</th>
                  <td mat-cell *matCellDef="let applicant">{{ applicant.requesterName }}</td>
                </ng-container>

                <!-- Applied Date Column -->
                <ng-container matColumnDef="dateOfApplication">
                  <th mat-header-cell *matHeaderCellDef>Date of application</th>
                  <td mat-cell *matCellDef="let applicant">{{ applicant.dateOfApplication | date:'dd MMM yyyy'}} </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let applicant">
                    <span class="status-chip" [ngClass]="getStatusClass(applicant.status.userStatus)">
                      <mat-icon class="status-icon">{{ getStatusIcon(applicant.status.userStatus) }}</mat-icon>
                      @if(applicant.status.userStatus == 'BDM Interview'){
                      DM Interview
                      }@else{
                      {{ applicant.status.userStatus }}
                      }
                    </span>
                  </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let applicant">
                    <div class="row-actions">
                      @if((['Candidate Submission','Candidate Update (Due Diligence)', 'Candidate Update (Assessment)','Onboarding Processing','BDM Interview','DSU Initial Assessment','DSU Final Assessment','DSU Manager Approval','Onboarding Completed'].includes(applicant.status.userStatus) && ['Director','Manager','Advisor'].includes(this.currentUserRole))
                      || (['Candidate Submission','Candidate Update (Due Diligence)', 'Candidate Update (Assessment)','Manager Review','BDM Interview','Rectification','DSU Initial Assessment','DSU Final Assessment','DSU Manager Approval','Onboarding Completed'].includes(applicant.status.userStatus) && ['Onboarding'].includes(this.currentUserRole)) ||
                      (['Candidate Submission', 'Candidate Update (Due Diligence)', 'Candidate Update (Assessment)','Manager Review','Onboarding Processing','BDM Interview','Rectification','DSU Manager Approval','Onboarding Completed'].includes(applicant.status.userStatus) && ['DSU'].includes(this.currentUserRole)) || 
                      (['Candidate Submission','Candidate Update (Due Diligence)', 'Candidate Update (Assessment)','Manager Review','Onboarding Processing','BDM Interview','Rectification','DSU Initial Assessment','DSU Final Assessment','Onboarding Completed'].includes(applicant.status.userStatus) && ['DSU Manager'].includes(this.currentUserRole)) ||
                      (['Candidate Submission','Candidate Update (Due Diligence)', 'Candidate Update (Assessment)','Manager Review','Onboarding Processing','Rectification','DSU Initial Assessment','DSU Final Assessment','DSU Manager Approval','Onboarding Completed'].includes(applicant.status.userStatus) && ['BDM'].includes(this.currentUserRole))){                      
                      <button mat-icon-button matTooltip="View" (click)="viewApplicant(applicant)"
                        class="action-icon-btn view-btn">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      }
                      @if((applicant.status.userStatus == 'Draft Created' && (this.currentUserRole == 'Director' ||
                      this.currentUserRole == 'Manager' || this.currentUserRole == 'Advisor')) ||
                      (applicant.status.userStatus == 'Manager Review' && (this.currentUserRole == 'Director' ||
                      this.currentUserRole == 'Manager' || this.currentUserRole == 'Advisor')) ||
                      (applicant.status.userStatus == 'Rectification' &&
                      (this.currentUserRole == 'Director' ||
                      this.currentUserRole == 'Manager' || this.currentUserRole == 'Advisor')) || (this.currentUserRole
                      == 'Onboarding' &&
                      applicant.status.userStatus == 'Onboarding Processing') || (this.currentUserRole == 'BDM' &&
                      applicant.status.userStatus == 'BDM Interview' ) || (this.currentUserRole == 'DSU' &&
                      (applicant.status.userStatus == 'DSU Initial Assessment' || applicant.status.userStatus == 'DSU Final Assessment')) || (this.currentUserRole == 'DSU Manager' && applicant.status.userStatus ==
                      'DSU Manager Approval' ) ){
                      <button mat-icon-button matTooltip="Edit" (click)="editApplicant(applicant)"
                        class="action-icon-btn edit-btn">
                        <mat-icon>edit</mat-icon>
                      </button>
                      }
                      <button mat-icon-button matTooltip="Onboarding History"
                        (click)="viewAuditLog(applicant)" class="action-icon-btn info-btn">
                        <mat-icon>info_outline</mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>

              </table>
            </div>

            <!-- Paginator -->
            <div class="paginator-wrapper">
              <span class="showing-text">
                Showing {{ pageIndex * pageSize + 1 }}–{{ getEndIndex() }} of {{ filteredApplicants.length }}
                applicants
              </span>
              <mat-paginator [length]="filteredApplicants.length" [pageSize]="pageSize"  [pageIndex]="pageIndex" [pageSizeOptions]="[5, 10, 25]"
                (page)="onPageChange($event)" hidePageSize="false" aria-label="Select page">
              </mat-paginator>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
    </div>
    }
  </div>

</app-pias-layout>